//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Icon from '@/js/vue/Icon';

export default {
  components: { Icon },
  props: {
    regionOpened: {
      type: Boolean,
      default: false,
    },
    regionName: {
      type: String,
      default: '',
    },
    popularsMarked: {
      type: Array,
      default: () => [],
    },
    list: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      jsv: 'javascript:void(0);',
    };
  },
};
